import React from 'react';
import { useTranslation } from 'react-i18next';

const LEGAL_BASE = process.env.REACT_APP_LEGAL_BASE || 'https://deal3dp.ru';

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const scrollTo = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const navLinks = [
    { label: t('nav.demo'),       href: '#demo' },
    { label: t('nav.howItWorks'), href: '#how-it-works' },
    { label: t('nav.features'),   href: '#features' },
    { label: t('nav.contact'),    href: '#contact' },
  ];

  const legalLinks = [
    { label: t('footer.privacy'), href: `${LEGAL_BASE}/privacy/` },
    { label: t('footer.consent'), href: `${LEGAL_BASE}/consent/` },
    { label: t('footer.cookie'),  href: `${LEGAL_BASE}/cookie/` },
    { label: t('footer.terms'),   href: `${LEGAL_BASE}/terms/` },
  ];

  return (
      <footer className="bg-gray-950 border-t border-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 mb-12">

            {/* Brand */}
            <div className="flex flex-col gap-4">
            <span className="text-lg font-bold text-white">
              3dp<span className="text-emerald-500">.</span>
            </span>
              <p className="text-gray-500 text-sm leading-relaxed max-w-xs">
                {t('footer.tagline')}
              </p>
            </div>

            {/* Nav links */}
            <div className="flex flex-col gap-3">
              <p className="text-xs font-semibold text-gray-600 uppercase tracking-widest mb-1">
                {t('footer.links')}
              </p>
              {navLinks.map(({ label, href }) => (
                  <a
                  key={href}
                href={href}
                onClick={(e) => scrollTo(e, href)}
                className="text-gray-400 text-sm hover:text-emerald-400 transition-colors"
                >
              {label}
                </a>
                ))}
            </div>

            {/* Legal */}
            <div className="flex flex-col gap-3">
              <p className="text-xs font-semibold text-gray-600 uppercase tracking-widest mb-1">
                {t('footer.legal')}
              </p>
              {legalLinks.map(({ label, href }) => (
                  <a
                  key={href}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 text-sm hover:text-emerald-400 transition-colors"
                >
              {label}
                </a>
                ))}
            </div>

          </div>

          <div className="pt-8 border-t border-gray-900">
            <p className="text-gray-600 text-sm">
              {t('footer.copyright', { year })}
            </p>
          </div>

        </div>
      </footer>
  );
};

export default Footer;
